// Copyright Caproc Oy
// System name: Aqua-Net
// System module: Layout
// Author: TS
//
// 4.6.2026 TS (claude) Fetch shared system version once and pass to Desktop/Mobile containers for display

import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import { withRouter } from "react-router-dom";
import DesktopContainer from "./Layout/DesktopContainer";
import MobileContainer from "./Layout/MobileContainer";
import { systemVersionURL } from "../constants";

class ResponsiveContainer extends React.Component {
    state = {
        version: null
    };

    componentDidMount() {
        axios
            .get(systemVersionURL())
            .then(res => this.setState({ version: res.data.version }))
            .catch(() => this.setState({ version: null }));
    }

    render() {
        const { children } = this.props;
        const { version } = this.state;
        return (
            <div>
                <DesktopContainer version={version}>{children}</DesktopContainer>
                <MobileContainer version={version}>{children}</MobileContainer>
            </div>
        );
    }
}

ResponsiveContainer.propTypes = {
    children: PropTypes.node
};

class CustomLayout extends React.Component {
    render() {
        return <ResponsiveContainer>{this.props.children}</ResponsiveContainer>;
    }
}

export default withRouter(CustomLayout);
